import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv3010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv3010SearchParams = z.infer<typeof Inv3010SearchParamsSchema>

export const Inv3010SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable(),
  date: z.coerce.date().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
})

export type Inv3010SearchResultModel = z.infer<
  typeof Inv3010SearchResultModelSchema
>

export const Inv3010SearchResultSchema = z
  .object({
    data: z.array(Inv3010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv3010SearchResult = z.infer<typeof Inv3010SearchResultSchema>

// Search Params Schema
export const Inv3010ItemLookupSearchParamsSchema = z.object({
  itemId: z
    .string()
    .optional()
    .refine((v) => {
      if (v) return !Number.isNaN(v) && Number(v) > 0
      return v
    }),
  lotNo: z.string().optional(),
})

export type Inv3010ItemLookupSearchParams = z.infer<
  typeof Inv3010ItemLookupSearchParamsSchema
>

// Search Result Model Schema
export const Inv3010ItemLookupModelSchema = z.object({
  id: z.number().default(0),
  itemId: z.number(),
  isClaimItem: z.boolean(),
  lotDate: z.coerce.date(),
  location: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  qty: z.number(),
  unit: z.string().default('pcs'),
})

export type Inv3010ItemLookupModel = z.infer<
  typeof Inv3010ItemLookupModelSchema
>

// Search Result Schema
export const Inv3010ItemLookupSearchResultSchema = z
  .object({
    data: z.array(Inv3010ItemLookupModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv3010ItemLookupSearchResult = z.infer<
  typeof Inv3010ItemLookupSearchResultSchema
>
